import {GetServerSideProps} from "next";
import {client} from "../../sanity/lib/client";
import Image from "next/image";
import {PortableText} from "@portabletext/react";
import {RichTextComponents} from "@/components/RichTextComponents";
import {Button} from "@/components/ui/button";
import {ChevronRight, CircleMinus, CirclePlus} from "lucide-react";
import React, { useEffect, useState } from "react";
import InfoCard from "@/components/permuta/InfoCard";
import FormRentToBuy from "@/components/FormRentToBuy";
import Head from "next/head";


export default function RentToBuyPage({data, faqs}: any) {

    const [backgroundImage, setBackgroundImage] = useState("");
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;
        setBackgroundImage(isMobile ? data.calculatorForm.backgroundImageMobile : data.calculatorForm.backgroundImage);
    }, [data]);


    const toggleFAQ = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const schemaOrgJsonLD = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Rent to Buy - Gruppo Piccirillo",
        "url": "https://gruppopiccirillo.it/rent-to-buy",
        "description": "Scopri il Rent to Buy del Gruppo Piccirillo. Flessibile come un noleggio, conveniente come un acquisto. Nessun vincolo, nessuna penale, massima libertà.",
        "publisher": {
            "@type": "Organization",
            "name": "Gruppo Piccirillo S.p.A.",
            "url": "https://gruppopiccirillo.it",
            "logo": {
                "@type": "ImageObject",
                "url": process.env.NEXT_PUBLIC_LOGO
            }
        },
        "image": data.heroRentToBuy.image
    };


    return (
        <>
            <Head>
                <title>Rent to Buy - Gruppo Piccirillo | Flessibile come un noleggio, conveniente come un acquisto</title>
                <meta name="description" content="Scopri il Rent to Buy del Gruppo Piccirillo: nessun vincolo, massima libertà. Guida senza pensieri e decidi tu quando cambiare auto." />
                <meta name="keywords" content="Rent to Buy, Noleggio auto, Acquisto auto, Auto senza vincoli, Gruppo Piccirillo, Auto usate, Noleggio a lungo termine, Senza penali, Flessibilità auto" />
                <meta name="author" content="Gruppo Piccirillo S.p.A." />
                <meta property="og:title" content="Rent to Buy - Gruppo Piccirillo" />
                <meta property="og:description" content="Flessibile come un noleggio, conveniente come un acquisto. Zero vincoli, massima libertà con il Rent to Buy del Gruppo Piccirillo." />
                <meta property="og:image" content="https://gruppopiccirillo.it/images/rent-to-buy-cover.jpg" />
                <meta property="og:url" content="https://gruppopiccirillo.it/rent-to-buy" />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Rent to Buy - Gruppo Piccirillo" />
                <meta name="twitter:description" content="Zero vincoli, massima libertà: il noleggio che si adatta a te." />
                <meta name="twitter:image" content="https://gruppopiccirillo.it/images/rent-to-buy-cover.jpg" />
                <link rel="canonical" href="https://gruppopiccirillo.it/rent-to-buy" />
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrgJsonLD) }}
                />
            </Head>
            <div className="relative w-full overflow-hidden">
                {/* Ellisse curva dietro la navbar */}


                {/* Contenuto */}
                <div className="relative z-30 text-center sm:pt-[120px] px-4 mb-[100px]">
                    <h1 className="text-white text-5xl max-sm:text-3xl md:text-6xl font-semibold leading-tight">
                        {data.heroRentToBuy.headline}
                    </h1>
                    <p className="text-[#C0C6FF] text-4xl max-sm:text-2xl py-4 font-normal">
                        {data.heroRentToBuy.subtext}
                    </p>
                    <div className="flex items-center justify-center my-6">
                        <Image
                            src={data.heroRentToBuy.image}
                            width={1100}
                            height={500}
                            alt="Car"
                            className="object-contain"
                        />
                    </div>
                    <p className="text-primary text-4xl max-sm:text-2xl max-sm:mt-20 font-light">
                        {data.heroRentToBuy.subtext2}
                    </p>
                    <div className="text-center mx-auto py-6 max-sm:py-3 text-black max-w-5xl text-2xl max-sm:text-lg">
                        <PortableText value={data.heroRentToBuy.description} components={RichTextComponents}/>
                    </div>
                </div>
            </div>


            <FormRentToBuy
                           backgroundImage={backgroundImage}
                           title={data.calculatorForm.title}
            />

           {/* <section
                className="h-[calc(100svh-100px)] max-sm:h-[calc(100svh-50px)] text-white"
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="h-full flex items-center">

                    <div className="flex flex-col max-w-xl text-center relative mx-auto max-sm:px-6 max-sm:my-8">
                        <h2 className="text-3xl max-sm:text-xl top-[-60px] relative font-bold mb-3">{}</h2>
                        <form className="flex flex-col items-center space-y-8 max-sm:mt-[30px]">
                            <div className="w-full flex flex-col text-left">
                                <Label htmlFor="title" className="font-bold text-xl">Nome e cognome</Label>
                                <Input type="text" placeholder="Il tuo nome per esteso"
                                       className="opacity-30 text-black"/>
                            </div>

                            <div className="w-full flex flex-col text-left">
                                <Label htmlFor="title" className="font-bold text-xl">Indirizzo</Label>
                                <Input type="text" placeholder="Il tuo indirizzo" className="opacity-30 text-black"/>
                            </div>

                            <div className="w-full flex flex-col text-left">
                                <Label htmlFor="title" className="font-bold text-xl">Email</Label>
                                <Input type="text" placeholder="La tua email" className="opacity-30 text-black"/>
                            </div>

                            <div className="w-full flex flex-col text-left">
                                <Label htmlFor="title" className="font-bold text-xl">Telefono</Label>
                                <Input type="text" placeholder="Il tuo telefono" className="opacity-30 text-black"/>
                            </div>

                            <Button className="bg-[#D73133] hover:bg-[#D73133]/90 w-[300px] text-white" type="submit">
                                Invia
                                <ChevronRight className="h-6 w-6 ml-2"/>
                            </Button>

                        </form>
                    </div>
                </div>


            </section>*/}

            <section className="my-[150px]">

                <div className="flex flex-col items-center space-y-8">
                    <Image src={data.carDetailExplanation.image}
                           className="max-sm:hidden"
                           width={1100}
                           height={500}
                           alt="Car"/>

                    <Image src={data.carDetailExplanation.backgroundImageMobile}
                           className="sm:hidden"
                           width={1100}
                           height={500}
                           alt="Car"/>
                </div>

                <div className="max-w-3xl mx-auto">
                    <div
                        className={`p-6 max-sm:m-4 flex flex-col md:flex-row items-center gap-x-4 bg-[#F8F9FD] border border-[#DBDBDB]  rounded-[42px] shadow-md `}>
                        <div className={`flex  max-sm:gap-x-2 gap-x-6 items-start  max-sm:pb-5`}>
                            <div className="flex items-center gap-4">
                                <div
                                    className="max-sm:text-3xl font-normal max-sm:w-16 max-sm:h-16 w-24 h-24 flex items-center justify-center border border-[#DBDBDB] bg-white rounded-full text-5xl ">
                                    <Image src={data.carDetailExplanation.icon}
                                           className="w-10"
                                           width={200}
                                           height={200}
                                           alt="Car"/>
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <h3 className="max-sm:text-[26px] text-primary text-[34px] font-normal">{data.carDetailExplanation.title}</h3>
                                <div className="max-sm:text-xl text-2xl md:leading-[140%] text-gray-600 mt-2">
                                    <PortableText value={data.carDetailExplanation.description}
                                                  components={RichTextComponents}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>


            <div className="my-[130px] max-sm:my-[100px] flex flex-col gap-y-10">

                <h4 className="text-7xl font-bold text-primary text-center max-sm:text-3xl">Come funziona?</h4>


                {data.infoCardSection.infoCards.map((card: any) => (
                    <InfoCard key={card._id} number={card.number} title={card.title}
                              description={card.description} imageUrl={card.image}
                              imageCar={card.imageCar} imagePosition={card.imagePosition}/>
                ))}

            </div>


            <section className="my-[150px] text-center">
                <h3 className="text-7xl max-sm:text-3xl text-primary font-bold">{data.audienceSection.title}</h3>
                <p className="text-primary max-sm:text-2xl font-light text-4xl">L'Opzione Perfetta per Ogni Necessità!</p>

                <div className="bg-radial-back flex max-sm:p-5 max-sm:py-24 p-10 mt-[45px] py-24 mx-auto">

                    <div
                        className="max-w-6xl text-white mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-12 gap-x-8 text-center">
                        {data.audienceSection.items.map((item: any, index: number) => (
                            <div key={index} className="flex flex-col items-center">
                                <div className="w-[80px] h-[80px] mb-4">
                                    {/* Icona, se presente */}
                                    {item.icon && (
                                        <Image
                                            width={100}
                                            height={100}
                                            src={item.icon}
                                            alt={item.title}
                                            className="w-full h-full object-contain"
                                        />
                                    )}
                                </div>
                                <h3 className="text-5xl max-sm:text-xl font-semibold">{item.title}</h3>
                                <p className="mt-2 text-[28px] max-sm:text-base opacity-80 px-4">{item.description}</p>
                            </div>
                        ))}
                    </div>


                </div>

            </section>

            <section className="my-[150px] text-center">
                <Image src={data.ctaSection.image} alt={data.ctaSection.title}
                       width={1700}
                       className="w-full h-full object-contain"
                       height={500}/>

                <h4 className="text-4xl max-sm:text-2xl text-primary font-light">{data.ctaSection.title}</h4>
                <div className="text-center max-sm:text-xl  mx-auto py-4 text-black max-w-5xl">
                    <PortableText value={data.ctaSection.description} components={RichTextComponents}/>
                </div>
                <Button className="bg-[#D73133] hover:bg-[#D73133]/90 w-[330px] text-white" type="submit" onClick={() => {
                    window.scrollTo({ top: 700, behavior: 'smooth' });
                }}>
                    Contattaci
                    <ChevronRight className="h-6 w-6 ml-2"/>
                </Button>
            </section>

            <div className="max-w-3xl mx-auto py-10 px-6">
                {/* Titolo */}
                <h2 className="text-7xl font-bold max-sm:text-center text-gray-900">FAQ</h2>
                <p className="text-gray-600 max-sm:text-center mt-2">
                    Tutto quello che devi sapere sull’iniziativa
                </p>

                {/* Lista FAQ */}
                <div className="mt-6 border-t border-gray-300">
                    {faqs.map((faq: any, index: number) => (
                        <div key={index} className="border-b border-gray-300">
                            <button
                                className="w-full flex justify-between items-center py-4 text-left font-semibold text-gray-900"
                                onClick={() => toggleFAQ(index)}
                            >
                                {faq.question}
                                {openIndex === index ? (
                                    <CircleMinus className="w-6 h-6 text-gray-500"/>
                                ) : (
                                    <CirclePlus className="w-6 h-6 text-gray-500"/>
                                )}
                            </button>
                            {openIndex === index && (
                                <p className="text-gray-700 text-sm leading-relaxed pb-4">
                                    <PortableText value={faq.answer} components={RichTextComponents}/>
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export const getServerSideProps: GetServerSideProps = async () => {
    try {
        const query = `*[_type == "rentToBuyPage"] | order(orderRank) {
  _id,
  title,
  seo,
  sections[] {
    _type,
    ...select(
      _type == "heroRentToBuy" => {
        headline,
        subtext,
        subtext2,
        "image": image.asset->url,
        description
      },
      _type == "calculatorForm" => {
        title,
        "backgroundImage": backgroundImage.asset->url,
        "backgroundImageMobile": backgroundImageMobile.asset->url
      },
      _type == "carDetailExplanation" => {
        title,
        description,
        "image": image.asset->url,
        "backgroundImageMobile": backgroundImageMobile.asset->url,
        "icon": icon.asset->url,
      },
      _type == "infoCardSection" => {
        "infoCards": infoCards[]->{
          number,
          title,
          description,
          "image": image.asset->url,
          "imageCar": imageCar.asset->url,
          imagePosition
        }
      },
      _type == "audienceSection" => {
        title,
        items[]{
          title,
          description,
          "icon": icon.asset->url
        }
      },
      _type == "ctaSection" => {
        "image": image.asset->url,
        title,
        description
      }
    )
  }
}[0]`;


        const faqQuery = `*[_type == "faq" && references(*[_type == "category" && references(*[_type == "section" && slug.current == $sectionSlug][0]._id)]._id)] | order(orderRank) {
  question,
  answer
}`;

        const [response, faqs] = await Promise.all([
            client.fetch(query),
            client.fetch(faqQuery, {sectionSlug: 'rent-to-buy'}),
        ]);


        if (!response) {
            return {
                notFound: true,
            };
        }

        // Trasforma l'array `sections` in un oggetto con chiavi separate
        const sectionsObject: { [key: string]: any } = {};
        response.sections?.forEach((section: any) => {
            if (section?._type) {
                sectionsObject[section._type] = section;
            }
        });

        // Rimuovi l'array `sections` e unisci le sezioni singole
        const {sections, ...rest} = response;

        console.log(JSON.stringify({
            ...rest,
            ...sectionsObject,
        }, null, 2));

        const data = {
            ...rest,
            ...sectionsObject,
        }

        return {
            props: {
                data,
                faqs
            },
        };
    } catch (error) {
        console.error('Error fetching section data:', error);
        return {props: {}};
    }
};

